import axios from "./axios";

export async function fetchUsers(controller) {
  let { filters, sort, sortBy, page, query, view, per_page, fields, active } = controller;

  const params = {
    query: query,
    page: page,
    per_page: per_page,
    sortBy: sortBy,
    sort: sort,
    filters: filters,
    view: view,
    fields: fields,
    active: active,
  };

  return axios({ method: "get", url: "/users/", params: params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchUser(id, params = {}) {
  return axios({ method: "get", url: `/users/${id}`, params: params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

/**
 * All assignable roles for company user UI. The /users/roles endpoint is paginated
 * (default per_page 25); without a large per_page, older roles (e.g. "calendar") can be missing.
 */
export async function fetchRoles(params = {}) {
  try {
    const metaRes = await axios({
      method: "get",
      url: `/users/roles`,
      params: { per_page: 1, page: 1, ...params },
    });
    const total = Number(metaRes?.data?.totalCount) || 0;
    const perPage = Math.min(Math.max(total, 1), 5000);
    return await axios({
      method: "get",
      url: `/users/roles`,
      params: { per_page: perPage, page: 1, ...params },
    });
  } catch (error) {
    return error;
  }
}
